/* CFW shopping-for preference (2026-09-17).
 *
 * One small store for "am I shopping for women's or men's", plus the plumbing
 * that makes the rest of the site act on it.
 *
 *   window.CFW.gender.get()        -> 'women' | 'men' | 'both' | null
 *   window.CFW.gender.set(v, how)  persist + apply + broadcast
 *   window.CFW.gender.clear()
 *   window.CFW.gender.param()      -> the Shopify facet query string, or ''
 *   window.CFW.gender.decorate(root)  add the facet to gender-aware links
 *
 * Fires `cfw:gender:changed` {value, source} on document.
 *
 * Storage is deliberately belt-and-braces: localStorage for persistence and a
 * cookie so the value survives in private windows where localStorage throws,
 * and so it is visible to anything server-side later. Every access is wrapped
 * because Safari private mode throws on localStorage.
 *
 * Shopify's target-gender taxonomy values: 18 = women, 19 = men. These match
 * snippets/cfw-gender-toggle.liquid; keep them in sync.
 */
(function (w, d) {
  'use strict';
  var CFW = (w.CFW = w.CFW || {});
  if (CFW.gender) return;

  var KEY = 'cfw_gender';
  var VALUES = { women: 1, men: 1, both: 1 };
  var FACET = 'filter.v.t.shopify.target-gender';
  var TAXONOMY = {
    women: 'gid://shopify/TaxonomyValue/18',
    men: 'gid://shopify/TaxonomyValue/19'
  };

  function readLS() {
    try { return w.localStorage.getItem(KEY); } catch (e) { return null; }
  }
  function writeLS(v) {
    try { w.localStorage.setItem(KEY, v); } catch (e) { /* private mode */ }
  }
  function clearLS() {
    try { w.localStorage.removeItem(KEY); } catch (e) {}
  }
  function readCookie() {
    var m = d.cookie.match(/(?:^|;\s*)cfw_gender=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function writeCookie(v) {
    var days = 180;
    var exp = new Date(Date.now() + days * 864e5).toUTCString();
    d.cookie = KEY + '=' + encodeURIComponent(v) + ';expires=' + exp + ';path=/;SameSite=Lax';
  }
  function clearCookie() {
    d.cookie = KEY + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
  }

  function get() {
    var v = readLS() || readCookie();
    return VALUES[v] ? v : null;
  }

  function param(value) {
    var v = value || get();
    if (!v || !TAXONOMY[v]) return '';
    return FACET + '=' + encodeURIComponent(TAXONOMY[v]);
  }

  /* Add the gender facet to links that opted in via data-cfw-gender-link.
     We never touch a link that already carries the facet, and never touch
     the orthotics collection (it runs its own gender logic). */
  /*
   * Paths that already carry a gender of their own. Forcing the shopper's
   * preference onto "/collections/womens-shoes" would produce a page that
   * contradicts its own title, or an empty one.
   */
  var SKIP = /\/collections\/(orthotics|(wo)?mens?-)/i;

  /* Remove any existing target-gender facet so the preference wins. */
  function stripFacet(url) {
    var parts = url.split('?');
    if (parts.length < 2) return url;
    var kept = parts[1].split('&').filter(function (pair) {
      return pair.indexOf(FACET + '=') !== 0;
    });
    return kept.length ? parts[0] + '?' + kept.join('&') : parts[0];
  }

  function decorate(root) {
    var v = get();
    var q = param(v);
    var scope = root || d;
    var links = Array.prototype.slice.call(scope.querySelectorAll('a[data-cfw-gender-link]'));

    /*
     * Header and footer navigation. Those links come from Horizon's own menu
     * blocks, which are shared theme files; decorating them from here keeps the
     * change in one place instead of spread across seven core snippets. Only
     * collection links are touched, and orthotics is excluded below because its
     * products are not tagged by gender the same way.
     */
    var navRoots = [d.getElementById('header-group'), d.querySelector('.shopify-section-group-footer-group')];
    navRoots.forEach(function (navRoot) {
      if (!navRoot) return;
      if (scope !== d && !scope.contains(navRoot) && !navRoot.contains(scope)) return;
      Array.prototype.forEach.call(navRoot.querySelectorAll('a[href*="/collections/"]'), function (a) {
        if (links.indexOf(a) === -1) links.push(a);
      });
    });

    Array.prototype.forEach.call(links, function (a) {
      var base = a.getAttribute('data-cfw-href') || a.getAttribute('href');
      if (!base) return;
      a.setAttribute('data-cfw-href', base);

      /*
       * Leave alone anything that is already about one gender by its own
       * nature: a "Women's shoes" menu entry, an orthotics link (those
       * products are not tagged by gender the same way), or a link an author
       * deliberately pointed at one side in the theme editor.
       */
      if (SKIP.test(base)) {
        a.setAttribute('href', base);
        return;
      }

      var clean = stripFacet(base);
      a.setAttribute('href', q ? clean + (clean.indexOf('?') > -1 ? '&' : '?') + q : clean);
    });
  }

  function apply(v) {
    var root = d.documentElement;
    if (v) root.setAttribute('data-cfw-gender', v);
    else root.removeAttribute('data-cfw-gender');
    decorate(d);
  }

  /* Hand the choice to Klaviyo as a profile property so it can be segmented
     on. Queued via _learnq, so it is safe to call before Klaviyo has loaded
     and harmless if Klaviyo never loads at all. */
  function toKlaviyo(v) {
    try {
      w._learnq = w._learnq || [];
      w._learnq.push(['identify', { 'Shopping For': v === 'both' ? 'Both' : (v === 'men' ? "Men's" : "Women's") }]);
    } catch (e) {}
  }

  function set(v, source) {
    if (!VALUES[v]) return;
    writeLS(v);
    writeCookie(v);
    apply(v);
    toKlaviyo(v);
    try {
      d.dispatchEvent(new CustomEvent('cfw:gender:changed', { detail: { value: v, source: source || 'unknown' } }));
    } catch (e) {}
  }

  function clear() {
    clearLS();
    clearCookie();
    apply(null);
    try {
      d.dispatchEvent(new CustomEvent('cfw:gender:changed', { detail: { value: null, source: 'clear' } }));
    } catch (e) {}
  }

  CFW.gender = { get: get, set: set, clear: clear, param: param, decorate: decorate, apply: apply, FACET: FACET };

  /* If a Klaviyo form collects "Shopping for", honour it. Klaviyo exposes the
     submitted fields on e.detail.metaData (developers.klaviyo.com). We look for
     any field whose name mentions shopping/gender and read men/women out of it,
     so it keeps working whatever Carter names the field. */
  w.addEventListener('klaviyoForms', function (e) {
    try {
      if (!e.detail || (e.detail.type !== 'submit' && e.detail.type !== 'stepSubmit')) return;
      var meta = e.detail.metaData || {};
      var found = null;
      Object.keys(meta).forEach(function (k) {
        if (found) return;
        if (!/shop|gender|for/i.test(k)) return;
        var val = String(meta[k] || '').toLowerCase();
        if (/wom|female|her|she/.test(val)) found = 'women';
        else if (/\bmen\b|male|him|his/.test(val)) found = 'men';
        else if (/both|either|all/.test(val)) found = 'both';
      });
      if (found) set(found, 'klaviyo');
    } catch (err) {}
  });

  /* Apply on load, and re-decorate after Shopify section re-renders. */
  apply(get());
  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', function () { decorate(d); });
  }
  d.addEventListener('shopify:section:load', function () { decorate(d); });
})(window, document);
